import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5537%3A4473
 *
 * @param {SvgIconProps} props - svg props
 */
export const ChevronDownIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M17.6528 10.5285C17.8452 10.3338 17.8452 10.0205 17.6528 9.82571L16.9453 9.10961C16.7497 8.91164 16.4301 8.91147 16.2343 9.10922L12 13.3856L7.76569 9.10922C7.56988 8.91147 7.2503 8.91164 7.05471 9.10961L6.3472 9.82571C6.15477 10.0205 6.15477 10.3338 6.3472 10.5285L11.6443 15.89C11.8401 16.0881 12.1599 16.0881 12.3557 15.89L17.6528 10.5285Z' fill={color}/>
        </SvgIcon>
    )
}

export default ChevronDownIcon
